var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGallery2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#0E0E0E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 18C12.45 18 12 18.45 12 19V23H12.01L12 32C12 33.1 12.9 34 14 34H31C31.55 34 32 33.55 32 33C32 32.45 31.55 32 31 32H15C14.45 32 14 31.55 14 31V19C14 18.45 13.55 18 13 18ZM34 16H26L24.59 14.59C24.21 14.21 23.7 14 23.17 14H18C16.9 14 16.01 14.9 16.01 16L16 28C16 29.1 16.9 30 18 30H34C35.1 30 36 29.1 36 28V18C36 16.9 35.1 16 34 16ZM19.6 26.2L23.11 21.52C23.31 21.26 23.7 21.25 23.91 21.51L27.01 25.5L29.11 22.97C29.31 22.72 29.69 22.73 29.89 22.98L32.38 26.18C32.64 26.51 32.4 26.99 31.99 26.99H20C19.59 27 19.35 26.53 19.6 26.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGallery2);
export default __webpack_public_path__ + "static/media/ic_gallery2.e65b24428c515f79461aa689f485cf71.svg";
export { ForwardRef as ReactComponent };